import { css } from 'styled-components';
export const width = css `
  ${({ $width, $maxWidth, $minWidth }) => `
    ${$width ? `width: ${$width};` : ''}
    ${$maxWidth ? `max-width: ${$maxWidth};` : ''}
		${$minWidth ? `min-width: ${$minWidth};` : ''}
  `}
`;
export const widthKeys = ['width', 'maxWidth', 'minWidth'];
